import React, { Fragment, FunctionComponent, useEffect } from 'react';
import Text from '../../../components/typography/typgraphy';
import "../error.scss"

const UpdateMobileError: FunctionComponent = () => {

  return (
    <Fragment>
      <Text className="error-description">Seems like we don’t have your mobile number in our systems.</Text>
      <Text className="error-description">Please visit your nearest Axis Bank branch for updating and then re-initiate your transaction.</Text>
    </Fragment>
  )
}

export default UpdateMobileError;
